/**
 * Adds "Forecast" to the given title.
 *
 * @param {string} title title
 * @returns {string} title with "Forecast" added
 */
const getCumPlusForecastTitle = (title, source: string, subgroup?: string) => {
  if (!title) return "";

  const cumIndex = title.indexOf("Cum");

  if (cumIndex < 0 || subgroup === "Cumulative" || subgroup == "Cumulative Ratios")
    return title;

  if (subgroup == "Date Range") {
    // "Cumulative Volume Across Range (Mbbl)" → "Cumulative Volume Across Range + Forecast (Mbbl)"
    const forecastSuffix = `+ Forecast${!source ? "" : " (" + source + ")"}`;
    const unitMatch = title.match(/(\s*\([^)]*\))$/);
    if (unitMatch) {
      return title.slice(0, unitMatch.index) + ` ${forecastSuffix}` + unitMatch[0];
    }
    return `${title} ${forecastSuffix}`;
  }

  const cumPlusForecastTitle =
    title.substr(0, cumIndex + 3) +
    ` + Forecast${!source ? "" : " (" + source + ")"}` +
    title.substr(cumIndex + 3);
  return cumPlusForecastTitle;
};

export default getCumPlusForecastTitle;
